module.exports = __webpack_public_path__ + "img/back.618f7eb7.jpg";